import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Mainlogocolor from "../images/Logo ez.png";
import Mainlogo from "../images/Logo_Color1.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import ShareIcon from "@mui/icons-material/Share";
import InboxIcon from "@mui/icons-material/Inbox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  INVOICE_ROUTE,
  DASHBOARD_ROUTE,
  SUPPLIERMANAGEMENT_ROUTE,
  MYTEAM_ROUTE,
  SETTINGS_ROUTE,
  METRICSINVOICE_ROUTE,
  MYCLIENTS_ROUTE,
  SIGNIN_ROUTE,
  PROFILE_ROUTE,
  ADD_SUPPLIER,
  NOTIFICATION_ROUTE,
  INBOX_ROUTE,
  INBOX_MY_APPROVALS_ROUTE,
} from "../constants/RoutePaths";
import { getRole, getUserId } from "../comman/function";
import { usePermissions, PERMISSIONS } from "../context/PermissionContext";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import MenuItem from "@mui/material/MenuItem";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { UNLOCK_INVOICE_URL, USER_SIGN_OUT_URL, DELETE_DEVICE } from "../comman/url";
import { authHeader } from "../comman/mainfunction";
import API from "../constants/API";
import { CustomMessage } from "../comman/helperfunction";
import { useSnackbar } from "notistack";
import { makeStyles } from "../tss";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { useSelector } from "react-redux";
import defaultprofile from "../images/defaultprofile.jpg";
import NotifyPopup from "./Notification/NotifyPopup";
import { useDispatch } from "react-redux";
import { getNotificationDetails } from "../redux/action";

const drawerWidth = 240;

const useStyles = makeStyles((_theme: any) => ({
  // TODO(types): MUI theme
  mainBox: {
    "& .MuiDrawer-paper": {
      borderRight: "none !important",
    },
  },
  selected: {
    color: "#EC7C37 !important",
    backgroundColor: "transparent !important",
    transitionDuration: "0s !important",
    transition: "none !important",
    borderLeft: "2px solid #ec7c37",

    "& .MuiTouchRipple-root": {
      display: "none !important",
    },
    "& .Mui-focusVisible": {
      backgroundColor: "red !important",
    },
    "& .MuiListItemIcon-root": {
      color: "#EC7C37",
    },
    "&:hover": {
      background: "transparent !important",
      transitionDuration: "0s !important",
      transition: "none !important",
    },
  },

  menuroot: {
    borderLeft: "2px solid transparent !important",
    "& .MuiListItemIcon-root": {
      color: "#a0a3bd",
    },
    "& .MuiListItemText-root": {
      color: "#a0a3bd",
    },
    "& .MuiTouchRipple-root": {
      display: "none !important",
    },
    "&:hover": {
      background: "transparent !important",
      transitionDuration: "0s !important",
      transition: "none !important",
    },
  },
}));

const openedMixin = (theme: any) => ({
  // TODO(types): MUI theme
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden" as const,
  backgroundColor: "#f9f9fa",
  borderRight: "0px solid rgba(0, 0, 0, 0)",
});

const closedMixin = (theme: any) => ({
  // TODO(types): MUI theme
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden" as const,
  backgroundColor: "#f9f9fa",
  width: `calc(${theme.spacing(9)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  backgroundColor: "#f9f9fa",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarOpenProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarOpenProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarOpenProps>(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Sidebar = () => {
  const styleclasses = useStyles();
  // TODO(types): Redux RootState typing
  const UserReducer = useSelector((s: any) => s.UserReducer); // TODO(types): redux state shape
  const isUploaded = useSelector((s: any) => s.DashboardReducer); // TODO(types): redux state shape
  const isEdit = useSelector((s: any) => s.EditReducer); // TODO(types): redux state shape

  // RBAC permissions
  const { hasAnyPermission } = usePermissions();

  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const invoiceId = localStorage.getItem("INVOICE_ID");
  //login menu
  const [anchorEl, setAnchorEl] = React.useState<any>(null);
  const popen = Boolean(anchorEl);
  const phandleClick = (event: any) => {
    // TODO(types): event handler arg
    setAnchorEl(event.currentTarget);
    openList1();
  };
  const phandleClose = () => {
    setAnchorEl(null);
  };
  const history = useNavigate();
  const dispatch = useDispatch();
  const viewMore = () => {
    // setFlag(!openFlag);
    history(NOTIFICATION_ROUTE);
  };
  //main menu
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
    openList1();
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const profileRoute = () => {
    history(PROFILE_ROUTE);
  };

  const [openFlag, setFlag] = useState(false);
  const [profileName, setProfileName] = useState("");
  const [profilePic, setProfilePic] = useState("");

  const openList = () => {
    setFlag(!openFlag);
  };
  const openList1 = () => {
    setFlag(false);
  };

  const handleProfileName = () => {
    // let tempName = UserReducer.userName;
    let tempName = localStorage.getItem("LOGIN_NAME") ?? "";
    const tempPic = localStorage.getItem("PROFILE_PIC") ?? "";
    setProfilePic(tempPic);
    if (tempName.length > 9) tempName = tempName.substring(0, 9).concat("....");
    setProfileName(tempName);
  };

  useEffect(() => {
    handleProfileName();
  });

  const lockedFun = () => {
    openList1();
    if (isEdit) {
      CustomMessage("Please Update/Cancel the invoice", "error", enqueueSnackbar); //call toster
    }
  };
  const logOutFunction = () => {
    if (invoiceId) {
      unLockInvoice();
      // deleteDevice();
    } else {
      logOutuser();
      // deleteDevice();
    }
  };
  const unLockInvoice = async () => {
    const config = {
      method: "DELETE",
      url: UNLOCK_INVOICE_URL,
      headers: authHeader(),
      params: {
        invoiceId: invoiceId,
        lockedBy: getUserId(),
      },
    };
    try {
      const response = await API(config);
      //const { status } = response.data;
      const { message } = response.data;

      if (message == "Success") {
        logOutuser();
      }
    } catch (error: any) {
      // TODO(types): error object
      if (error.response) {
        const { data } = error.response;

        const v = data;

        CustomMessage(v.message, "error", enqueueSnackbar); //call toster

        // Swal.fire(getAlert("Error", v.message));
      }
    } finally {
      logOutuser();
    }
  };
  const count = useSelector((countnot: any) => countnot.NotificationCountReducer); // TODO(types): redux state shape
  // const [count, setCount] = useState<any>();
  // const getNotificationDetails = async () => {
  //   const config = {
  //     method: "GET",
  //     url: GET_NOTIFICATION_URL,

  //     headers: authHeader(),
  //     params: {
  //           userId: getUserId(),
  //         },
  //   };

  //   try {
  //     const response = await API(config);
  //     //  const { status, data } = response.data;
  //     let l = response.data;
  //     const { status, messageCount, readedMessages, unreadedMessages } =
  //       JSON.parse(l);
  //     if (status === "Success") {
  //       setCount(messageCount[0].totalCount);
  //       dispatch({
  //         type: NOTIFY_COUNT,
  //         payload: messageCount[0].totalCount,
  //       });
  //     }
  //   } catch (error: any) { // TODO(types): error object
  //   }
  // };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (dispatch as any)(getNotificationDetails());
  }, [dispatch]);

  const handleError = () => {
    CustomMessage("Please Save the Changes", "error", enqueueSnackbar);
  };
  const _deleteDevice = async () => {
    const config = {
      method: "DELETE",
      url: DELETE_DEVICE,
      headers: authHeader(),
      params: {
        userId: getUserId(),
        deviceId: localStorage.getItem("Device_ID"),
      },
    };
    try {
      const response = await API(config);
      // const { status, data: initialResponse = [] } = response.data;
      const { status } = response.data;

      if (status === "Success") {
        // setTeamDetails(initialResponse[0]);
        //localStorage.setItem("Suppliermaintanceemail", data[0].supplierMaintenanceEmail);
      }
    } catch (error: any) {
      // TODO(types): error object
      // Swal.fire("Error", error);
      if (error.response) {
        // Swal.fire("Error", parsedErr.message);
        // CustomMessage(parsedErr.message, "error", enqueueSnackbar); //call toster
      }
    }
  };

  const logOutuser = async () => {
    const config = {
      method: "PUT",
      url: USER_SIGN_OUT_URL,
      headers: authHeader(),
      data: {
        userId: getUserId(),
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;

      if (status == "Success") {
        CustomMessage("Account has been logged out", "success", enqueueSnackbar); //call toster
        localStorage.clear();
        history(SIGNIN_ROUTE);
      }
    } catch {}
  };

  const imageStyle: React.CSSProperties = {
    height: "42px",
    width: "40px",
    borderRadius: "10px",
    marginRight: "8px",
    objectFit: "cover",
  };

  return (
    <Box className={styleclasses.mainBox}>
      <CssBaseline />
      <AppBar
        sx={{ border: "none !important" }}
        position="fixed"
        open={open}
        style={{
          boxShadow: "none",
          background: "transparent",
          width: "0",
          left: "0",
        }}
      >
        <Toolbar sx={{ paddingLeft: "5px !important" }}>
          <IconButton
            style={{
              color: "#000",
              backgroundColor: "rgb(249 249 250)",
              padding: "5px",
            }}
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <Link to={DASHBOARD_ROUTE}>
              <img
                src={Mainlogocolor}
                alt="ez cloud"
                style={{ marginRight: "6px", width: "34px", marginLeft: "6px" }}
              ></img>
            </Link>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          border: "none !important",
          borderRight: "0px solid rgba(0, 0, 0, 0)",
        }}
        variant="permanent"
        open={open}
      >
        <DrawerHeader
          sx={{
            backgroundColor: "#f9f9fa !important",
            borderRight: "none !important",
          }}
        >
          <Link to={isUploaded ? "#" : DASHBOARD_ROUTE} onClick={openList1}>
            <img src={Mainlogo} alt="ez cloud"></img>
          </Link>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <MenuIcon /> : <MenuIcon />}
          </IconButton>
        </DrawerHeader>
        <Box sx={{ borderRight: "none !important" }}>
          <List
            className="menusroot"
            sx={{ border: "none !important", mt: 2 }}
            onClick={isUploaded ? handleError : undefined}
          >
            <Link
              to={isEdit || isUploaded ? "#" : DASHBOARD_ROUTE}
              onClick={isEdit ? lockedFun : () => {}}
            >
              <ListItemButton
                selected={location.pathname.toString().includes(DASHBOARD_ROUTE)}
                className={
                  location.pathname.toString().includes(DASHBOARD_ROUTE)
                    ? styleclasses.selected
                    : styleclasses.menuroot
                }
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className={styleclasses.menulinkicon}
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <DashboardIcon onClick={openList1} />
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>Dashboard</ListItemText>
              </ListItemButton>
            </Link>
            {/* Inbox - Primary navigation for workflow users (includes Invoices All) */}
            {["Admin", "Super Admin", "Team Member"].includes(getRole()) && (
              <Link
                to={isEdit || isUploaded ? "#" : INBOX_MY_APPROVALS_ROUTE}
                onClick={isEdit ? lockedFun : () => {}}
              >
                <ListItemButton
                  selected={
                    location.pathname.toString().includes(INBOX_ROUTE) ||
                    location.pathname.toString().includes(INVOICE_ROUTE)
                  }
                  className={
                    location.pathname.toString().includes(INBOX_ROUTE) ||
                    location.pathname.toString().includes(INVOICE_ROUTE)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <InboxIcon onClick={openList1} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>Inbox</ListItemText>
                </ListItemButton>
              </Link>
            )}
            {["Supplier", "Sub Supplier"].includes(getRole()) ? (
              <Link to={isEdit ? "#" : MYCLIENTS_ROUTE} onClick={isEdit ? lockedFun : () => {}}>
                <ListItemButton
                  selected={location.pathname.toString().includes(MYCLIENTS_ROUTE)}
                  className={
                    location.pathname.toString().includes(MYCLIENTS_ROUTE)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <PeopleAltIcon onClick={openList1} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>My Clients</ListItemText>
                </ListItemButton>
              </Link>
            ) : null}
            {["Supplier", "Sub Supplier"].includes(getRole()) ? (
              <Link
                to={isEdit || isUploaded ? "#" : ADD_SUPPLIER}
                onClick={isEdit ? lockedFun : () => {}}
              >
                <ListItemButton
                  selected={location.pathname.toString().includes(ADD_SUPPLIER)}
                  className={
                    location.pathname.toString().includes(ADD_SUPPLIER)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <ShareIcon onClick={openList1} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>Users</ListItemText>
                </ListItemButton>
              </Link>
            ) : null}
            {/* Suppliers - Show for non-Supplier roles */}
            {!["Supplier", "Sub Supplier"].includes(getRole()) ? (
              <>
                <Link
                  to={isEdit || isUploaded ? "#" : SUPPLIERMANAGEMENT_ROUTE}
                  onClick={isEdit ? lockedFun : () => {}}
                >
                  <ListItemButton
                    selected={location.pathname.toString().includes(SUPPLIERMANAGEMENT_ROUTE)}
                    className={
                      location.pathname.toString().includes(SUPPLIERMANAGEMENT_ROUTE)
                        ? styleclasses.selected
                        : styleclasses.menuroot
                    }
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <ShareIcon onClick={openList1} />
                    </ListItemIcon>
                    <ListItemText sx={{ opacity: open ? 1 : 0 }}>Suppliers</ListItemText>
                  </ListItemButton>
                </Link>
              </>
            ) : null}
            {/* Metrics - Show for Admin only */}
            {["Admin", "Super Admin"].includes(getRole()) ? (
              <Link
                to={isEdit || isUploaded ? "#" : METRICSINVOICE_ROUTE}
                onClick={isEdit ? lockedFun : () => {}}
              >
                <ListItemButton
                  selected={location.pathname.toString().includes(METRICSINVOICE_ROUTE)}
                  className={
                    location.pathname.toString().includes(METRICSINVOICE_ROUTE)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <SignalCellularAltIcon sx={{ borderBottom: "2px solid" }} onClick={openList1} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>Metrics</ListItemText>
                </ListItemButton>
              </Link>
            ) : null}
            {/* Users - Show if Admin OR has user management permissions */}
            {(["Admin", "Super Admin"].includes(getRole()) ||
              hasAnyPermission([PERMISSIONS.ADMIN_USERS_VIEW, PERMISSIONS.ADMIN_USERS_MANAGE])) && (
              <Link
                to={isEdit || isUploaded ? "#" : MYTEAM_ROUTE}
                onClick={isEdit ? lockedFun : () => {}}
              >
                <ListItemButton
                  selected={location.pathname.toString().includes(MYTEAM_ROUTE)}
                  className={
                    location.pathname.toString().includes(MYTEAM_ROUTE)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <PeopleAltIcon onClick={openList1} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>Users</ListItemText>
                </ListItemButton>
              </Link>
            )}
            {/* Administration - Show if Admin/Super Admin OR has any admin permission */}
            {(["Admin", "Super Admin"].includes(getRole()) ||
              getRole() === "Super Admin" ||
              hasAnyPermission([
                PERMISSIONS.ADMIN_SETTINGS_VIEW,
                PERMISSIONS.ADMIN_SETTINGS_MANAGE,
                PERMISSIONS.ADMIN_USERS_VIEW,
                PERMISSIONS.ADMIN_WORKFLOW_VIEW,
              ])) && (
              <Link
                to={isEdit || isUploaded ? "#" : SETTINGS_ROUTE}
                onClick={isEdit ? lockedFun : () => null}
              >
                <ListItemButton
                  selected={location.pathname.toString().includes(SETTINGS_ROUTE)}
                  className={
                    location.pathname.toString().includes(SETTINGS_ROUTE)
                      ? styleclasses.selected
                      : styleclasses.menuroot
                  }
                  sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }}
                >
                  <ListItemIcon
                    sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}
                  >
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>Administration</ListItemText>
                </ListItemButton>
              </Link>
            )}
          </List>
        </Box>

        {openFlag && !isUploaded && (
          <NotifyPopup openFlag={openFlag} openList={openList} setFlag={setFlag} />
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            position: "absolute",
            bottom: "1rem",
            width: "100%",
          }}
        >
          <IconButton
            onClick={!isUploaded ? phandleClick : handleError}
            size="small"
            sx={{
              width: "80%",
              color: "#14142A",
              fontWeight: 500,
              fontSize: "14px",
              "&:hover": {
                backgroundColor: "unset",
              },
              "&:selected": {
                backgroundColor: "unset",
              },
            }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <img
              src={
                UserReducer.profilePic != "" &&
                UserReducer.profilePic != "null" &&
                UserReducer.profilePic != undefined
                  ? profilePic
                  : defaultprofile
              }
              alt=""
              style={imageStyle}
            />{" "}
            {/* {open && UserReducer.userName} */}
            {open && <Typography>{profileName}</Typography>}
            {/* < Badge sx={{ ml: 1, color: "#fff" }} badgeContent={4} color="error">
              <NotificationsIcon color="primary" />
            </Badge> */}
          </IconButton>
          <Tooltip title="Notifications">
            <Badge sx={{ ml: 1, color: "#fff" }} badgeContent={count} color="error">
              <NotificationsIcon
                color="primary"
                sx={{ cursor: "pointer" }}
                onClick={count > 0 || isUploaded ? openList : viewMore}
              />
            </Badge>
          </Tooltip>
        </Box>
        <Menu
          elevation={0}
          style={{ borderRight: "unset", marginTop: "-55px" }}
          anchorEl={anchorEl}
          id="account-menu"
          open={popen}
          onClose={phandleClose}
          onClick={phandleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              // mt: 1,
              width: open ? "184px" : "67px",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
                border: "non",
              },
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "top" }}
        >
          <MenuItem
            onClick={profileRoute}
            style={{ borderBottom: "#e7e8ec solid 1px" }}
            disabled={isUploaded}
          >
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            {/* {getLoginName()} */}
            {open && "Profile"}
          </MenuItem>
          <MenuItem
            //  onClick={logOutuser}
            onClick={logOutFunction}
            disabled={isUploaded}
          >
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            {open && "Logout"}
          </MenuItem>
        </Menu>
      </Drawer>
      <DrawerHeader />
      {/* <Outlet /> */}
    </Box>
  );
};

export default Sidebar;
